import { SavedFilterInterface } from '../../../interfaces/saved-filter.interface';

export class SaveFilterSuccessAction {
    public static readonly type = '[JobsPlacements] Save filter success';

    constructor(public payload: SavedFilterInterface) { }
}
